import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-eab4fec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Program Code", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Program Name", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_8 = { class: "table-box" }
const _hoisted_9 = { class: "tableBtn" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Reject To SICCO")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Submit To Controlling")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Operate ")
const _hoisted_15 = {
  key: 0,
  class: "pagination-container d-f justify-e"
}
const _hoisted_16 = { class: "title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "rect"
}, null, -1))
const _hoisted_18 = { class: "wrap-title" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Do you confirm ")
const _hoisted_20 = { style: {"color":"#13b4f0"} }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" below programs")
const _hoisted_22 = { class: "codeCover" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_retail_eligibility_modal = _resolveComponent("retail-eligibility-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_space, {
        class: "feature-con",
        ref: "searchCon",
        align: "end"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_a_space, {
              direction: "vertical",
              style: {"margin-right":"15px","margin-bottom":"5px","width":"214px"}
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_input, {
                  value: _ctx.queryListParams.programCode,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queryListParams.programCode) = $event)),
                  placeholder: "Please Input"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              direction: "vertical",
              style: {"margin-right":"15px","margin-bottom":"5px","width":"214px"}
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_a_input, {
                  value: _ctx.queryListParams.programNameEn,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.queryListParams.programNameEn) = $event)),
                  placeholder: "Please Input"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_a_space, {
              direction: "vertical",
              style: {"margin-left":"15px","margin-bottom":"5px"}
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_a_button, { onClick: _ctx.clearQueryListParams }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              direction: "vertical",
              style: {"margin-left":"15px","margin-bottom":"5px"}
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createVNode(_component_a_button, {
                  onClick: _ctx.getTableDataClick,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_a_space, {
            direction: "vertical",
            style: {"margin-left":"15px","margin-bottom":"5px"}
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createVNode(_component_a_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRejectToSICCOData('N')))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_space, {
            direction: "vertical",
            style: {"margin-left":"15px","margin-bottom":"5px"}
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _createVNode(_component_a_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getSubbmitControlling('N'))),
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_table, {
          class: "ant-table-striped",
          rowKey: "id",
          columns: _ctx.columns,
          "data-source": _ctx.queryListData,
          pagination: false,
          "row-selection": _ctx.rowSelection,
          scroll: { y: _ctx.tableHeight },
          rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        }, {
          operation: _withCtx(({ record }) => [
            _createVNode(_component_router_link, {
              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
              class: "ellipsis ds-block",
              title: "Operate",
              to: {
              path: '/paymentApprove/paymentPreparationDetail',
              query: {
                progDesignId: record.progDesignId,
                offerTypeId: record.offerTypeId,
                programBus: _ctx.programBusStr,
                programBuIds: _ctx.programBuIdsStr,
                programCode: record.programCode,
                programName: record.programName,
                programCategory: record.programCategory
              }
            }
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["columns", "data-source", "row-selection", "scroll", "rowClassName"])
      ]),
      (_ctx.queryListData && _ctx.queryListData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_a_pagination, {
              total: _ctx.pagination.total,
              "show-size-changer": "",
              "show-total": (total) => `共 ${total} 条`,
              onChange: _ctx.changePagination,
              onShowSizeChange: _ctx.changePageSize,
              pageSize: _ctx.pagination.pageSize,
              "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pagination.pageSize) = $event)),
              currentPage: _ctx.pagination.currentPage,
              "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pagination.currentPage) = $event)),
              pageSizeOptions: ['10', '20', '30', '40', '50']
            }, {
              buildOptionText: _withCtx((props) => [
                _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
              ]),
              _: 1
            }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "pageSize", "currentPage"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        visible: _ctx.isBtnCover,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isBtnCover) = $event)),
        onCancel: _ctx.closeBtnCover,
        class: "batch-query-modal",
        "z-index": 999,
        width: "600px",
        centered: ""
      }, {
        title: _withCtx(() => [
          _createElementVNode("section", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("span", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.coverInfo.coverTit), 1),
              _hoisted_21
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            size: "small",
            onClick: _ctx.closeBtnCover
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.coverInfo.type === 'rejecttosicco')
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                size: "small",
                type: "primary",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRejectToSICCOData('Y')))
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                size: "small",
                type: "primary",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getSubbmitControlling('Y')))
              }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              }))
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_a_table, {
              class: "ant-table-striped",
              rowKey: "id",
              columns: _ctx.coverColumns,
              "data-source": _ctx.coverDataSource,
              pagination: false,
              rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
            }, {
              No: _withCtx(({ index }) => [
                (index + 1 === _ctx.coverDataSource.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Total "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(index + 1), 1))
              ]),
              _: 1
            }, 8, ["columns", "data-source", "rowClassName"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "onCancel"])
    ]),
    _createVNode(_component_retail_eligibility_modal, {
      visible: _ctx.checkVisible,
      onClose: _ctx.closeCheckModal,
      checkDataSource: _ctx.checkDataSource,
      checkData: _ctx.checkData,
      onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.submitToCon('Y')))
    }, null, 8, ["visible", "onClose", "checkDataSource", "checkData"])
  ], 64))
}